"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const Image_1 = require("@components/atoms/Image");
const _store_1 = __importDefault(require("@store")); // Component
var HomepageHero = function HomepageHero() {
    var _ref$current, _ref$current2, _heroBackground$file, _heroMobileBackground, _heroMobileBackground2, _heroBackground$file2, _heroMobileBackground3, _heroColumnOneBody$ch, _heroColumnOneBody$ch2, _heroColumnTwoBody$ch, _heroColumnThreeBody$;
    var _useStaticQuery = gatsby_1.useStaticQuery(query), contentfulLandingPage = _useStaticQuery.contentfulLandingPage;
    if (!contentfulLandingPage)
        return null;
    var _useGlobal = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.setUser;
    }), user = _useGlobal3[0];
    var join = function join() {
        setVisibleDropdown('account');
        setPanel('pricing');
    };
    var _useElementScroll = _utils_1.useElementScroll(), position = _useElementScroll.position, setRef = _useElementScroll.setRef, ref = _useElementScroll.ref;
    var heroColumnOneTitle = contentfulLandingPage.heroColumnOneTitle, heroColumnTwoTitle = contentfulLandingPage.heroColumnTwoTitle, heroColumnThreeTitle = contentfulLandingPage.heroColumnThreeTitle, heroColumnOneBody = contentfulLandingPage.heroColumnOneBody, heroColumnTwoBody = contentfulLandingPage.heroColumnTwoBody, heroColumnThreeBody = contentfulLandingPage.heroColumnThreeBody, heroBackground = contentfulLandingPage.heroBackground, heroMobileBackground = contentfulLandingPage.heroMobileBackground;
    var max = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollWidth) - ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clientWidth);
    var percentageScrolled = position.x / max;
    var windowExists = typeof window !== "undefined";
    var spill = windowExists ? window.innerWidth - 680 : 0;
    var scroll = spill * (1 - percentageScrolled);
    var cdnSrc = _utils_1.imgixPath(heroBackground === null || heroBackground === void 0 ? void 0 : (_heroBackground$file = heroBackground.file) === null || _heroBackground$file === void 0 ? void 0 : _heroBackground$file.url);
    var mobileCdnSrc = (heroMobileBackground === null || heroMobileBackground === void 0 ? void 0 : (_heroMobileBackground = heroMobileBackground.file) === null || _heroMobileBackground === void 0 ? void 0 : _heroMobileBackground.url) ? _utils_1.imgixPath(heroMobileBackground === null || heroMobileBackground === void 0 ? void 0 : (_heroMobileBackground2 = heroMobileBackground.file) === null || _heroMobileBackground2 === void 0 ? void 0 : _heroMobileBackground2.url) : cdnSrc;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledMargin, {
        noGutter: true
    }, /*#__PURE__*/ react_1.default.createElement(BackgroundImage, Object.assign({
        src: heroBackground === null || heroBackground === void 0 ? void 0 : (_heroBackground$file2 = heroBackground.file) === null || _heroBackground$file2 === void 0 ? void 0 : _heroBackground$file2.url,
        mobileSrc: heroMobileBackground === null || heroMobileBackground === void 0 ? void 0 : (_heroMobileBackground3 = heroMobileBackground.file) === null || _heroMobileBackground3 === void 0 ? void 0 : _heroMobileBackground3.url
    }, {
        scroll: scroll
    }, {
        alt: "welcome to Prior"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(max-width: 767px)",
        srcSet: mobileCdnSrc + "?fm=webp&w=1360"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 1280px)",
        srcSet: cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['desktop'] + ", " + cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['desktop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 1024px)",
        srcSet: cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['laptop'] + ", " + cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['laptop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/webp",
        media: "(min-width: 768px)",
        srcSet: cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['tablet'] + ", " + cdnSrc + "?fm=webp&w=" + Image_1.sizes['bodyMargin']['tablet'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(max-width: 767px)",
        srcSet: mobileCdnSrc + "?fm=jp2&w=1360"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 1280px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['desktop'] + ", " + cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['desktop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 1024px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['laptop'] + ", " + cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['laptop'] * 2 + " 2x"
    }), /*#__PURE__*/ react_1.default.createElement("source", {
        type: "image/jp2",
        media: "(min-width: 768px)",
        srcSet: cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['tablet'] + ", " + cdnSrc + "?fm=jp2&w=" + Image_1.sizes['bodyMargin']['tablet'] * 2 + " 2x"
    })), /*#__PURE__*/ react_1.default.createElement(Overflow, {
        ref: setRef
    }, /*#__PURE__*/ react_1.default.createElement(Panels, null, user && /*#__PURE__*/ react_1.default.createElement(molecules_1.HomepageHeroPanel, {
        headline: heroColumnOneTitle,
        body: heroColumnOneBody === null || heroColumnOneBody === void 0 ? void 0 : (_heroColumnOneBody$ch = heroColumnOneBody.childMarkdownRemark) === null || _heroColumnOneBody$ch === void 0 ? void 0 : _heroColumnOneBody$ch.html,
        to: "/account",
        cta: "View"
    }), !user && /*#__PURE__*/ react_1.default.createElement(molecules_1.HomepageHeroPanel, {
        headline: heroColumnOneTitle,
        body: heroColumnOneBody === null || heroColumnOneBody === void 0 ? void 0 : (_heroColumnOneBody$ch2 = heroColumnOneBody.childMarkdownRemark) === null || _heroColumnOneBody$ch2 === void 0 ? void 0 : _heroColumnOneBody$ch2.html,
        onClick: function onClick() {
            return join();
        },
        cta: "Join"
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.HomepageHeroPanel, {
        headline: heroColumnTwoTitle,
        body: heroColumnTwoBody === null || heroColumnTwoBody === void 0 ? void 0 : (_heroColumnTwoBody$ch = heroColumnTwoBody.childMarkdownRemark) === null || _heroColumnTwoBody$ch === void 0 ? void 0 : _heroColumnTwoBody$ch.html,
        to: "/experiences",
        cta: "Explore"
    }), /*#__PURE__*/ react_1.default.createElement(molecules_1.HomepageHeroPanel, {
        headline: heroColumnThreeTitle,
        body: heroColumnThreeBody === null || heroColumnThreeBody === void 0 ? void 0 : (_heroColumnThreeBody$ = heroColumnThreeBody.childMarkdownRemark) === null || _heroColumnThreeBody$ === void 0 ? void 0 : _heroColumnThreeBody$.html,
        to: "/inspiration",
        cta: "Discover"
    }), /*#__PURE__*/ react_1.default.createElement(Spacer, null)))));
}; // Styling
var BackgroundImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).attrs(function (_ref) {
    var scroll = _ref.scroll;
    return {
        style: {
            transform: "translateX(" + scroll + "px)"
        }
    };
}).withConfig({
    displayName: "HomepageHero__BackgroundImage",
    componentId: "hlxsc9-0"
})(["position:absolute !important;z-index:0;height:100%;will-change:transform;> picture img{object-fit:contain !important;}", "{width:680px;}", "{transform:none !important;will-change:none;width:100%;}"], _utils_1.mediaQuery('tablet', 'max'), _utils_1.mediaQuery('tablet'));
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "HomepageHero__Wrapper",
    componentId: "hlxsc9-1"
})(["padding:32px 0;", "{padding:40px 0;}", "{padding:48px 0;}", "{padding:64px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "HomepageHero__StyledMargin",
    componentId: "hlxsc9-2"
})(["position:relative;max-width:100%;padding:0;overflow:hidden;&::after{z-index:2;position:absolute;top:0;right:0;background:linear-gradient( 90deg,", " 0%,", " 100% );height:calc(100% - 2px);width:24px;pointer-events:none;content:'';opacity:0.8;}", "{&::after{display:none;}}", "{max-width:1024px;}", "{max-width:1280px;}"], _utils_1.rgba(_theme_1.palette.ivory, 0), _utils_1.rgba(_theme_1.palette.ivory, 1), _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Overflow = styled_components_1.default.div.withConfig({
    displayName: "HomepageHero__Overflow",
    componentId: "hlxsc9-3"
})(["display:flex;justify-content:center;max-width:100%;overflow-y:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0px;height:0px;}", "{overflow:hidden;}"], _utils_1.mediaQuery('tablet'));
var Panels = styled_components_1.default.div.withConfig({
    displayName: "HomepageHero__Panels",
    componentId: "hlxsc9-4"
})(["position:relative;display:grid;grid-auto-flow:column;width:fit-content;max-width:100%;padding-left:8px;", "{padding-left:0;}"], _utils_1.mediaQuery('tablet'));
var Spacer = styled_components_1.default.div.withConfig({
    displayName: "HomepageHero__Spacer",
    componentId: "hlxsc9-5"
})(["display:block;background:transparent;width:40px;height:100%;", "{display:none;}"], _utils_1.mediaQuery('tablet')); // Types
// Data
var query = "3094137518";
exports.default = HomepageHero;
